exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lm-size-container{position:absolute!important;top:32px;bottom:0;left:0;right:0;padding:0 15px;background-color:#fff;border-radius:15px;-webkit-transition:border-radius .5s ease;transition:border-radius .5s ease}.lm-size.active .lm-size-container,.lm-size:hover .lm-size-container{border-radius:0 0 15px 15px}.lm-size-container .lm-size-preview-rows{padding-top:8px;margin-left:auto;margin-right:auto;overflow:auto}", ""]);

// exports
